module.exports = __webpack_public_path__ + "static/img/normal_fish_bg.39d0417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece/normal_fish_bg.png
// module id = 1Cdn
// module chunks = 0